import upperFirst from 'lodash.upperfirst';
import flatten from 'lodash.flatten';
import getLinkToPublishedContent from './get-link-to-published-content';
import getLoopPropsLimit from './get-loop-props-limit';
import getPropValue from './get-prop-value';
import { processDataSummaryValue } from '../../../helpers';

const getLoopValue = value => {
  const { keyField } = value;
  return value[keyField];
};

const separateValues = (propsToDisplay, loopProps, data) => {
  const regularValues = {};
  const loopValues = {};

  propsToDisplay.forEach(options => {
    const { propertiesToDisplay } = options;
    propertiesToDisplay.forEach(prop => {
      const value = getPropValue(prop, data, options);
      const isArrayValue = Array.isArray(value);
      if (!value) return;
      const isLoopableProp = loopProps.includes(prop) && isArrayValue;

      if (isLoopableProp) {
        loopValues[prop] = value;
      } else {
        regularValues[prop] = value;
      }
    });
  });
  return [regularValues, loopValues];
};

const buildLoopPropsContent = (
  loopProps = [],
  propsToDisplay = [],
  limit = 0,
  data = {},
  isSlider = false
) => {
  const loopPropsWithContent = [];
  const [regularValues, loopValues] = separateValues(propsToDisplay, loopProps, data);
  const loopLimit = getLoopPropsLimit(loopValues, limit);

  for (let i = 0; i < loopLimit; i += 1) {
    const propsArray = flatten(
      propsToDisplay.map(options => {
        const { propertiesToDisplay, label, modifier = '' } = options;

        return propertiesToDisplay.map(key => {
          const loopValue = loopValues[key];
          const loopValueItem = loopValue && loopValue[i];
          const propValue = loopValueItem ? getLoopValue(loopValueItem) : regularValues[key];
          if (!propValue) return null;

          const processedValue = processDataSummaryValue(propValue, options);
          const linkToPublishedContent = getLinkToPublishedContent(key, data, loopValueItem);
          return [upperFirst(label), processedValue, linkToPublishedContent, modifier];
        });
      })
    ).filter(Boolean);
    loopPropsWithContent.push(propsArray);
  }
  if (isSlider) return loopPropsWithContent;
  return flatten(loopPropsWithContent);
};

export default buildLoopPropsContent;
